module.exports = __webpack_public_path__ + "img/Versorgungsstelle_Verpflegung.2c0093c1.svg";